import { ALGOLIA_PRODUCT_INDEX } from '~/lib/constants'

export default function getAlgoliaProductIndex(): string {
  return `${process.env.NEXT_PUBLIC_ENV}_${ALGOLIA_PRODUCT_INDEX}`
}
